import { createAction, props } from '@ngrx/store';
import { GetEndUsersParams, GetEndUsersResponse } from 'src/app/core/proto';

export enum ConsumersActionTypes {
  EndUsersListGet = '[Consumers] End User List Get',
  EndUsersListGetSuccess = '[Consumers] End User List Get Success',
  EndUsersListGetFailure = '[Consumers] End User List Get Failure',
}

// EndUsersList
export const actionEndUsersListGet = createAction(
  ConsumersActionTypes.EndUsersListGet,
  props<{ body: GetEndUsersParams }>()
);

export const actionEndUsersListGetSuccess = createAction(
  ConsumersActionTypes.EndUsersListGetSuccess,
  props<{ payload?: GetEndUsersResponse }>()
);

export const actionEndUsersListGetFailure = createAction(
  ConsumersActionTypes.EndUsersListGetFailure
);
